<template>
  <div id="SiteLogin" class="Main-Content">

    <Page>
      <Layout>
        <LayoutSection>
          <form autocomplete>
            <Card :title="$t('Login')" v-if="!twoFactor">
              <CardSection>
                <div v-if="error" class="message error">{{ error }}</div>
                <div v-if="message" class="message">{{ message }}</div>

                <FormLayout>

                  <TextField
                    :label="$t('Email')"
                    v-model="email"
                    :disabled="trying"
                    ref="email"
                    name="email"
                  />
                  <TextField
                    :label="$t('Password')"
                    type="password"
                    v-model="password"
                    :disabled="trying"
                    ref="password"
                    name="password"
                  />

                  <Button type="primary" id="login" fullWidth @click="login" :disabled="trying">{{ $t('Login') }}</Button>
                </FormLayout>

              </CardSection>
              <CardSection>
                <Stack distribution="fillEvenly">
                  <Button fullWidth @click="$router.push('/site/forgotPassword/')">{{ $t('I forgot my password') }}</Button>
                  <Button fullWidth @click="$router.push('/site/register/')">{{ $t('Register') }}</Button>
                </Stack>
              </CardSection>
            </Card>
            <Card v-else>
              <CardSection>
                <div class="message">{{$t('SiteLogin.A code is being sent to you given your chosen Two Factor method')}}</div>
                <FormLayout>
                  <TextField
                    :label="$t('Code')"
                    v-model.trim="code"
                    :disabled="trying"
                    ref="code"
                    name="code"
                  />
                  <Button type="primary" fullWidth @click="validateTwoFactor" :disabled="trying">{{$t('Validate Code')}}</Button>
                </FormLayout>
              </CardSection>
            </Card>
          </form>
        </LayoutSection>
      </Layout>
    </Page>
    
  </div>
</template>

<script>

export default {
  name: 'SiteLogin',
  data () {
    return {
      error: '',
      message: '',
      trying: false,
      email: '',
      password: '',
      twoFactor: false,
      code: '',
      redirectTo: ''
    }
  },
  mounted() {
    this.$refs.email.focus()
  },
  computed: {
  },
  methods: {
    login() {
      this.error = ''
      this.message = ''
      if (!this.email) {
        this.error = this.$t('SiteLogin.Please enter an email')
        this.$refs.email.focus()
        return
      }
      if (!this.password) {
        this.error = this.$t('SiteLogin.Please enter a password')
        this.$refs.password.focus()
        return
      }
      this.trying = true
      return this.api.login(this.email.trim(), this.password.trim())
        .then(async (response) => {
          await this.processPostLogin(response)

          // 2 factor and not passed
          if (this.theUser.twoFactorAuthentication && this.theUser.twoFactorAuthentication.substr(0, 1) !== 'p') {
            return this.api.twoFactorSendCode()
            .then(() => {
              this.trying = false
              this.twoFactor = true
            })
            .catch((err) => {
              this.error = err
            })
            .finally(() => {
              this.trying = false
            })
          } else {
            await this.loadExtraDetails()

            if (this.$route.query && this.$route.query.next) {
              this.$router.push(this.$route.query.next)
            } else {
              this.$router.push('/')
            }
          }
        })
        .catch((err) => {
          this.error = err
        })
        .finally(() => {
          this.trying = false
        })
    },
    validateTwoFactor() {
      this.error = ''
      this.message = ''
      if (!this.code) {
        this.error = this.$t('Code Required')
        return
      }
      this.trying = true
      return this.api.twoFactorValidateCode(this.code)
        .then(async (response) => {
          // all is good!
          await this.processPostLogin(response)
          await this.loadExtraDetails()

          if (this.$route.query && this.$route.query.next) {
            this.$router.push(this.$route.query.next)
          } else {
            this.$router.push('/')
          }
        })
        .catch((err) => {
          this.error = err && err.message
        })
        .finally(() => {
          this.trying = false
        })
    }
  },
  components: {
  }
}

</script>

<style lang="scss" scoped>
.message {
  padding: 5px;
}
.error {
  color: #c00;
  font-weight: bold;
  margin-bottom: 20px;
}
</style>
